module.exports = __webpack_public_path__ + "img/cryptoz_cards_explained.36f3f7d9.jpg";